export default __webpack_public_path__ + "static/media/place_vendome_sunset.1619a570.jpg";